import "../Surveys.css";

//react
import { useEffect } from "react";

//components
import Confidence from "../../graphs/Surveys/nationMig/Confidence";
import Discrimination from "../../graphs/Surveys/nationMig/Discrimination";
import IplDiscrimination from "../../graphs/Surveys/nationMig/IplDiscrimination";
import IplIntegration from "../../graphs/Surveys/nationMig/IplIntegration";
import PublicDiscrimination from "../../graphs/Surveys/nationMig/PublicDiscrimination";
import SurveyGraphSection from "../../../components/reusable/SurveyGraphSection/SurveyGraphSection";

//antd
import { Divider } from "antd";

//css
import "../Surveys.css";

//hooks
import { useCurrentLanguage } from "../../../hooks/useCurrentLanguage";

//assets
import TEXT from "../../../utils/text/surveys_national_mig.json";

export default function NationalMig() {
    //language
    const { language } = useCurrentLanguage();

    //useEffect
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
            window.dataLayer.push({
            event: 'pageview'
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    return (
        <>
          <div className="surveys-page-content">
            <div className="surveys-page-graphs">
              <SurveyGraphSection
                graphID="feelings-graph"
                title={TEXT["discrimination"]["title"][language]}
                description={TEXT["discrimination"]["description"][language]}
                description2={TEXT["discrimination"]["description2"][language]}
                source={TEXT["discrimination"]["source"][language]}
                graphComponent={<Discrimination isHomePageGraph={false} />}
                language={language}
              />
              <Divider className="divider-full-screen" />
              <SurveyGraphSection
                graphID="feelings-graph"
                title={TEXT["public_discrimination"]["title"][language]}
                //description={TEXT["public_discrimination"]["description"][language]}
                description={<span><b>{TEXT["public_discrimination"]["text1_b"][language]}</b> {TEXT["public_discrimination"]["text1"][language]} <b>{TEXT["public_discrimination"]["text2_b"][language]}</b> {TEXT["public_discrimination"]["text2"][language]}</span>}
                source={TEXT["public_discrimination"]["source"][language]}
                graphComponent={<PublicDiscrimination/>}
                language={language}
                textPlacement="right"
              />
              <Divider className="divider-full-screen" />
              <SurveyGraphSection
                graphID="feelings-graph"
                title={TEXT["ipl_discrimination"]["title"][language]}
                description={<span>{TEXT["ipl_discrimination"]["text1"][language]} <a href="https://immigrationlab.org/ipl-integration-index/" rel="noopener noreferrer" target="_blank">{TEXT["ipl_discrimination"]["text_a"][language]}</a> {TEXT["ipl_discrimination"]["text2"][language]} <b>{TEXT["ipl_discrimination"]["text1_b"][language]}</b></span>}
                source={TEXT["ipl_discrimination"]["source"][language]}
                graphComponent={<IplDiscrimination/>}
                language={language}
              />
              <Divider className="divider-full-screen" />
              <SurveyGraphSection
                graphID="feelings-graph"
                title={TEXT["ipl_integration"]["title"][language]}
                description={<span>{TEXT["ipl_integration"]["text1"][language]} <b>{TEXT["ipl_integration"]["text_b"][language]}</b> {TEXT["ipl_integration"]["text2"][language]}</span>}
                source={TEXT["ipl_integration"]["source"][language]}
                graphComponent={<IplIntegration isHomePageGraph={false} />}
                language={language}
                textPlacement="right"
              />
              <Divider className="divider-full-screen" />
              <SurveyGraphSection
                graphID="feelings-graph"
                title={TEXT["confidence"]["title"][language]}
                description={<span>{TEXT["confidence"]["text1"][language]} <b>{TEXT["confidence"]["text_b"][language]}</b> {TEXT["confidence"]["text2"][language]}</span>}
                source={TEXT["confidence"]["source"][language]}
                graphComponent={<Confidence isHomePageGraph={false} />}
                language={language}
              />
            </div>
          </div>
        </>
  );
}
